
  <template>
    <div>
      <h1>Q&A Board</h1>
      <GenericBoard :headers="headers" :items="qaItems" :items-per-page="15" />
    </div>
  </template>
  
  <script>
  import GenericBoard from '@/components/GenericBoard.vue'
  
  export default {
    components: {
      GenericBoard
    },
    data() {
      return {
        headers: ['번호', '제목', '작성자', '작성일', '답변상태'],
        qaItems: [
          {
            number: 1,
            title: 'Vue.js 관련 질문입니다',
            author: '홍길동',
            date: '2024-06-15',
            status: '답변완료'
          },
          
        ]
      }
    },
    
  }
  </script>